import { CommittedLoad, CommittedLoadDefault } from "./committedLoad";

export const createCommittedLoadFromPropertyValue = (value: string): CommittedLoad => {
  if (value != null && value.length > 0) {
    return JSON.parse(value, (key, value) => {
      // when we hit a "connections" array, its items already have date: Date
      if (key === "connections" && Array.isArray(value)) {
        return value.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
      }

      return value;
    });
  }

  return CommittedLoadDefault;
};
